function Flavour({ flavour }) {
  return (
    <div className="flavour_para">
      <p>{flavour.name}</p>
    </div>
  );
}

export default Flavour;
